import React, { useEffect } from 'react';
import { Form, Input, Button } from 'antd';
import './ResetPassword.css';
import Index from '../Index';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { MRFverifyActionHandler } from '../../Redux/Actions/common/MfaAuthentications';
import { notification } from 'antd';

const ResetPassword = () => {
    const mainLogo = '/assets/QA_Logo.svg';
    const dispatch = useDispatch();
    let Navigate = useNavigate();
    const [api, contextHolder] = notification.useNotification();

    const isNewPassword = useSelector(
        (state) => state?.MfaAuthenticationsData?.mfaVerifyCodeMessage
    );
    const openNotificationWithIcon = (type) => {
        api[type]({ message: isNewPassword?.message });
    };
    useEffect(() => {
        if (isNewPassword) {
            if (isNewPassword.data.token) {
                localStorage.setItem('token', isNewPassword.data.token);
                localStorage.setItem(
                    'userDetails',
                    JSON.stringify(isNewPassword.data.user)
                );
                openNotificationWithIcon('success');
                setTimeout(() => {
                    Navigate('/');
                }, 2000);
            } else {
            }
        }
    }, [isNewPassword]);

    const onVerifyProcessFinish = (values) => {
        const session = localStorage.getItem('session');
        const session_email = localStorage.getItem('session_email');
        const updatedValues = {
            session: session,
            challenge_name: 'NEW_PASSWORD_REQUIRED',
            challenge_responses: {
                USERNAME: session_email,
                NEW_PASSWORD: values.newPassword,
            },
        };
        dispatch(MRFverifyActionHandler(updatedValues));

        window.dataLayer.push({
            event: 'Forgot password',
            buttonName: 'Forgot password',
            userId: JSON.parse(localStorage.getItem('userDetails'))?.id,
            clientId: JSON.parse(localStorage.getItem('userDetails'))
                ?.client_id,
        });
    };

    return (
        <>
            <div className='login-container'>
                <Index />
                {contextHolder}
                <div className='login-main'>
                    <div className='login-div'>
                        <div className='center-img'>
                            <img
                                src={mainLogo}
                                alt=''
                                className='centered-image'
                            />
                        </div>
                        <p className='login_text'>New Password</p>
                        <Form
                            className='reset-password-form'
                            name='loginForm'
                            initialValues={{ newPassword: '' }}
                            onFinish={onVerifyProcessFinish}>
                            <label>Enter your new password to continue.</label>
                            <Form.Item
                                name='newPassword'
                                rules={[
                                    {
                                        required: true,
                                        message: 'Please input your password!',
                                    },
                                    {
                                        min: 8,
                                        message:
                                            'Password must be at least 8 characters long',
                                    },
                                ]}>
                                <Input placeholder='Password' />
                            </Form.Item>
                            <Form.Item>
                                <Button
                                    type='primary'
                                    htmlType='submit'
                                    block
                                    className='submit_login-btn'>
                                    Verify and Login
                                </Button>
                            </Form.Item>
                        </Form>
                    </div>
                </div>
            </div>
        </>
    );
};

export default ResetPassword;
